<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">
    <div class="md-layout-item md-elevation-0">

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Observaciones Adicionales
        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
            Ante cualquier duda, comuníquese con su promotor.
          </p>
        </md-card-content> 
      </md-card>   


      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Observaciones Adicionales
        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
            El PARTICIPE declara haber recibido el Contrato de Administración entre el PARTICIPE y LA ADMINISTRADORA sometiéndose
            a todas las condiciones establecidas en el mismo; haber sido informado sobre lo concerniente a los factores de riesgo y variabilidad de la rentabilidad del Fondo Mutuo y de las cuotas; y haber recibido y aceptado el Prospecto Simplificado del Fondo
            Mutuo como constancia de todo, lo cual firma a continuación.           
          </p>
          <p align="justify">
            El partícipe declara conocer que La ADMINISTRADORA podrá cobrar a los partícipes una comisión de suscripción de hasta
            1.00% de su aporte, más el IGV correspondiente y demás tributos aplicables. Actualmente, no se cobra dicha comisión de
            suscripción, sin embargo, la ADMINISTRADORA podrá activar este cobro dentro de dicho rango, bastando para ello una
            notificación a los partícipes a través del estado de cuenta y en la página web (www.farocapital.pe), con una anticipación no menor a 15 días útiles para que entre en vigencia los cambios.
                        
          </p>
          <p align="justify">
            EL PARTICIPE se somete al Reglamento de Participación el mismo que se encuentra publicado en la página web de la
            Superintendencia del Mercado de Valores (www.smv.gob.pe) y que será entregado a su solicitud con antelación a la firma del
            Contrato de Suscripción.            
          </p>
          <p align="justify">
            El PARTÍCIPE declara haber sido informado que la rentabilidad o ganancia obtenida en el pasado por los Fondos Mutuos
            administrados por FARO CAPITAL SAF S.A. no garantiza que ella se mantendrá o evidenciará en el futuro y que los valores de
            las cuotas de los Fondos Mutuos son variables. Los términos con mayúsculas que no se encuentren definidos en el presente
            documento, tendrán el significado que les otorga en el Contrato de Administración.            
          </p>
          <p align="justify">
            "La rentabilidad o ganancia obtenida en el pasado, no garantiza que se repita en el futuro. Esta rentabilidad no incluye el efecto de las comisiones de suscripción y rescate, ni el impuesto a la renta".            
          </p>

        </md-card-content> 
      </md-card>        

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('confirmacion')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Suscribe usted las observaciones brindadas: *
        </md-card-header>
        <md-card-content class="md-layout">
          
            
            <div>
              <md-checkbox v-model="form.confirmacion" value="Si">Sí, es conforme</md-checkbox>
            </div>

            <div class="radioform" :class="getValidationClass('confirmacion')">
              <span class="md-error" v-if="!$v.form.confirmacion.required">Esta respuesta es obligatoria.</span>
            </div>              

        </md-card-content> 
      </md-card>           

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>                  
      
    </div>
  </form>
</template>

<style>

</style>

<script>
import { validationMixin } from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  name: 'Form9',
  data: () => ({
    form:{
      confirmacion: null
    }
  }),
  mounted: function(){
    this.form = this.$store.state.form.form9

  },  
  validations: {
    form: {
      confirmacion: {
        required,
      },
    },
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.form.form9
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        
        this.$emit('setSaveForm', {id:"9", form: this.form, index: "10"});

      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },        
  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }          
}
</script>
